import { EventEmitter } from '@angular/core';
// import {UserService} from '../../modules/permission/user/user.service';
// import {Subject} from 'rxjs/Subject';
// import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
// import {SubSink} from 'subsink';
// import * as _ from 'lodash';
var CommentComponent = (function () {
    function CommentComponent() {
        this.submitted = new EventEmitter();
        this.newComment = '';
    }
    CommentComponent.prototype.ngOnInit = function () {
    };
    CommentComponent.prototype.addComment = function () {
        var _this = this;
        var comment = [{ newComment: this.newComment }];
        this.submitted.emit(comment);
        setTimeout(function () {
            _this.newComment = '';
        }, 600);
    };
    CommentComponent.prototype.handleEnterKey = function ($event) {
        $event.preventDefault();
        this.addComment();
    };
    return CommentComponent;
}());
export { CommentComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/core/comment/comment.component.ts.pre-build-optimizer.js